import { useCallback } from "react";
import { useSidebarContext } from "../context/SidebarContext";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Box from "@mui/material/Box";

interface SidebarToggleButtonProps {
    /**
     * Whether the sidebar should not be collapsible to a mini variant in desktop and tablet viewports.
     * @default false
     */
    disableCollapsibleSidebar?: boolean;
}

export function SidebarToggleButton({ disableCollapsibleSidebar }: SidebarToggleButtonProps) {
    const {
        isDesktopNavigationExpanded,
        isMobileNavigationExpanded,
        toggleNavigationExpanded
    } = useSidebarContext();

    // menu icon for toggling the sidebar state
    const getMenuIcon = useCallback(
        (isExpanded: boolean) => {
            const expandMenuActionText = 'Expand';
            const collapseMenuActionText = 'Collapse';

            return (
                <Tooltip
                    title={`${isExpanded ? collapseMenuActionText : expandMenuActionText} menu`}
                    enterDelay={1000}
                >
                    <div>
                        <IconButton
                            aria-label={`${isExpanded ? collapseMenuActionText : expandMenuActionText} navigation menu`}
                            onClick={toggleNavigationExpanded}
                        >
                            {isExpanded ? <MenuOpenIcon /> : <MenuIcon />}
                        </IconButton>
                    </div>
                </Tooltip>
            );
        },
        [toggleNavigationExpanded],
    );

    return (
        <Box
            display="contents"
        >
            <Box display={{ md: 'none' }}>
                {getMenuIcon(isMobileNavigationExpanded)}
            </Box>
            <Box display={{ xs: 'none', md: disableCollapsibleSidebar ? 'none' : 'block' }}>
                {getMenuIcon(isDesktopNavigationExpanded)}
            </Box>
        </Box>
    );
}